module.exports = __webpack_public_path__ + "img/logo.df3dcc27.png";